import { Valence } from '@upright/common/model/types';
import { ElbowConnectors } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/connectors/elbow-connectors';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { valenceToSide } from '@upright/ui/common/upright/core/impact-lens-profile/common/utils';
import { targetLensLayout } from '@upright/ui/common/upright/core/impact-lenses/targets/common/layout';
import { useTargetsLensContext } from '@upright/ui/common/upright/core/impact-lenses/targets/common/use-targets-lens-context';
import {
  getTargetInfoBoxDataWithBoundsForSelection,
  mergeTargets,
} from '@upright/ui/common/upright/core/impact-lenses/targets/common/utils';

import { useCarouselContext, useCarouselLayout } from '../../../impact-lens-profile/context';

export function TargetsInfoBoxConnectors() {
  const { lensIndex, previousLensIndex } = useCarouselContext();
  const baseLayout = useCarouselLayout();
  const ctx = useTargetsLensContext();
  const entityTargets = ctx?.data.targets;
  const sbtiTargets = ctx?.data.sbtiTargets;
  const allTargets = mergeTargets(entityTargets, sbtiTargets);
  if (!allTargets || (!entityTargets && !sbtiTargets)) {
    return <></>;
  }
  if (baseLayout.boxMode === LensBoxMode.MODAL) {
    return <></>;
  }
  const layout = targetLensLayout(baseLayout, entityTargets);
  const boxData = getTargetInfoBoxDataWithBoundsForSelection(
    baseLayout,
    allTargets,
    lensIndex,
    previousLensIndex,
    ctx.selection,
  );
  const connectors = boxData.map(d => {
    const x1 = d.valence === Valence.POSITIVE ? d.bounds.x1 : d.bounds.x2;
    const y1 = d.bounds.cy;
    const sa = layout.impactTargetSymbolArea(valenceToSide(d.valence), d.impact);
    const x2 = d.valence === Valence.POSITIVE ? sa.x2 : sa.x1;
    const y2 = sa.cy;
    return { x1, x2, y1, y2 };
  });
  return <ElbowConnectors connectors={connectors} />;
}
